import { Skeleton } from 'antd';
import React, { FC } from 'react';
import {
  Wrapper,
  ConversationList,
  ConversationPane,
  MessageItem,
  ListItem,
  ListTitle,
} from './project-conv-skeleton.styles';

export const ProjectConversationSkelton: FC = () => {
  return (
    <Wrapper>
      <ConversationList>
        <Skeleton.Input style={{ width: 180 }} size="small" />
        <ListTitle>
          <Skeleton paragraph={{ rows: 1, width: 200 }} title={false} />
        </ListTitle>
        {Array.from(Array(4).keys()).map((value) => {
          return (
            <ListItem key={value}>
              <Skeleton paragraph={{ rows: 1 }} title={false} />
            </ListItem>
          );
        })}
        <ListTitle>
          <Skeleton paragraph={{ rows: 1, width: 220 }} title={false} />
        </ListTitle>
        {Array.from(Array(7).keys()).map((value) => {
          return (
            <ListItem key={value}>
              <Skeleton paragraph={{ rows: 1 }} title={false} />
            </ListItem>
          );
        })}
      </ConversationList>
      <ConversationPane>
        {Array.from(Array(6).keys()).map((value) => {
          return (
            <MessageItem key={value}>
              <Skeleton.Avatar shape="square" size="large" />
              <Skeleton paragraph={{ rows: 2 }} />
            </MessageItem>
          );
        })}
      </ConversationPane>
    </Wrapper>
  );
};
